import { Button, Stack, Typography } from "@mui/material";
import { routerPaths } from "../../constants/Paths";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import SuccessAlert from "../../components/common/alert/SuccessAlert";
import BroadCastingDetailsSectionComponent from "../../components/panel/broadcasting-details/broadcasting-sub/BroadCastingDetailsSection";
import UserOverviewCard from "../../components/panel/common/UserOverviewCard";
import { useState } from "react";
import { IUserLink } from "../../components/panel/common/UserLink";
import { NumberListColumnFilterable } from "../../services/Endpoints/broadcast/NumbersEndpoint";
import { FilterOperatorEnum } from "../../services/Schemas/ListQueryString";
import { useUrl } from "../../hooks/urlEncoding";
import { useCanAccess } from "../../hooks/canAccess";
import { AccessEnums } from "../../constants/accessEnum";
import { useProtectedAxiosInstance } from "../../hooks/axiosInstance";
import { useNotificationContext } from "../../context/notificationContext";
import { BroadcastingDetailsRequest } from "../../services/Endpoints/broadcast";
import errorResolver from "../../utils/error-resolver";
import { LoadingButton } from "@mui/lab";

export default function BroadCastingDetailsPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const { queryStringUrl } = useUrl();
  
  const [creator, setCreator] = useState<IUserLink["user"] | undefined>(
    undefined
  );
  const [status, setStatus] = useState("");

  const { can } = useCanAccess();

  const [waiting, setWaiting] = useState(false);
  const protectedInstance = useProtectedAxiosInstance();
  const { setNotification } = useNotificationContext();

  const handleCampaignCancel = async (id: string) => {
    try {
      setWaiting(true);
      const broadcastingDetailsRequest = new BroadcastingDetailsRequest(
        protectedInstance
      );
      await broadcastingDetailsRequest.cancel({
        broadcastingNumber: id,
      });
      setWaiting(false);
      setNotification({ type: "success", message: "کمپین با موفقیت لغو شد." });
      navigate("/" + routerPaths.VOICE_BROADCASTS);
    } catch (error) {
      errorResolver({ error, setNotification });
      setWaiting(false);
    }
  };

  return (
    <>
      <Stack
        width="100%"
        direction="column"
        justifyContent="start"
        alignItems="start"
        px={{ xs: "8px", md: "20px" }}
        gap="10px"
      >
        <UserOverviewCard user={creator} />
        <Stack direction={"column"} width="100%">
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ md: "center", xs: "start" }}
            mb={{ xs: "6px", md: "0" }}
            width="100%"
          >
            <Stack>
              <Typography
                variant="h4DemiBold"
                color={({ palette }) => palette.dominant.main}
                sx={{
                  mb: "4px",
                  mt: { xs: "0px", sm: "24px" },
                }}
              >
                جزئیات پیام صوتی
              </Typography>
              <Typography
                variant="footerDemiBold"
                color={({ palette }) => palette.complement[300]}
                sx={{
                  mb: "20px",
                }}
              >
                جزئیات پیام صوتی
              </Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              gap="12px"
            >
              <Stack
                sx={{
                  textDecoration: "none",
                }}
                component={
                  can(AccessEnums.AdminVoiceBroadcastNumbersList) ? Link : Stack
                }
                to={queryStringUrl(routerPaths.BROAD_NUMBER, {
                  filters: [
                    {
                      column: NumberListColumnFilterable.VOICE_BROADCAST_ID,
                      operator: FilterOperatorEnum.EQUAL,
                      value: id,
                    },
                  ],
                })}
              >
                <Button variant="activeOutlined">شماره ها</Button>
              </Stack>

              {can(AccessEnums.AdminVoiceBroadcastsCancel) && (
                <LoadingButton
                  onClick={() => handleCampaignCancel(id!)}
                  variant="dangerOutlined"
                  disabled={
                    !can(AccessEnums.AdminVoiceBroadcastsCancel) ||
                    status == "canceled"
                  }
                  loading={waiting}
                >
                  کنسل کردن کمپین
                </LoadingButton>
              )}
              <Button
                onClick={() => navigate(-1)}
                variant="contained"
              >
                بازگشت
              </Button>
            </Stack>
          </Stack>
        </Stack>
        <BroadCastingDetailsSectionComponent
          id={id!}
          setCreator={setCreator}
          setStatus={setStatus}
        />
      </Stack>
    </>
  );
}
